import { render, staticRenderFns } from "./replacementPerformanceStackedColumnChart.vue?vue&type=template&id=486c14d4"
import script from "./replacementPerformanceStackedColumnChart.vue?vue&type=script&lang=js"
export * from "./replacementPerformanceStackedColumnChart.vue?vue&type=script&lang=js"
import style0 from "./replacementPerformanceStackedColumnChart.vue?vue&type=style&index=0&id=486c14d4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports